const validateNDC = async (_: any, value: any) => {
  if (!value || value.length === 11) {
    return Promise.resolve();
  }
  return Promise.reject(new Error('A valid NDC Code must be exactly 11 numerical digits long.'))
};

export { validateNDC };